import {
  MenuItem,
  Box,
  Button,
  Divider,
  Menu,
  Typography,
} from '@mui/material';

import ButtonGradient from 'components/ButtonGradient';
import FilterClaimchainInMap from 'components/FilterButton/FilterClaimchainInMap';
import FilterPlotStatus from 'components/FilterButton/FilterPlotStatus';
import IOSSwitch from 'components/IOSSwitch';
import React from 'react';
import SearchPlot from 'components/SearchPlotForMap';
import TuneIcon from '@mui/icons-material/Tune';
import { initFilter } from 'pages/PublicPage/Layout';
import { useMainContext } from 'pages/PublicPage/Layout';

export default function FilterButton() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [state, setState] = React.useState(initFilter);
  const { filter, setFilter } = useMainContext();
  const hasFilter = JSON.stringify(initFilter) !== JSON.stringify(filter);
  const setStatus = (value) => {
    setState({
      ...state,
      status: value,
    });
  };
  const setShowClaimchain = (value) => {
    setState({
      ...state,
      showClaimchain: value,
    });
  };
  const setShowUnConnect = (value) => {
    setState({
      ...state,
      showUnConnect: value,
    });
  };
  React.useEffect(() => {
    if (anchorEl) {
      setState(filter);
    }
  }, [anchorEl]);
  const status = state.status;
  const showClaimchain = state.showClaimchain;
  const showUnConnect = state.showUnConnect;
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      position={'absolute'}
      top={'13px'}
      right={{
        xs: '206px',
        md: '38.5vw',
      }}
      zIndex={10}
      borderLeft={'1px solid rgba(255, 255, 255, 0.2)'}
    >
      <Button
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        color="third"
        variant="contained"
        sx={{
          borderTopRightRadius: '30px',
          borderBottomRightRadius: '30px',
          background: 'transparent',
          color: 'white',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
            background: 'rgba(255, 255, 255, 0.1)',
          },
        }}
      >
        <TuneIcon sx={{ mr: '4px' }} />
        Filter
        {hasFilter && (
          <Box
            sx={{
              bgcolor: '#FFD874',
              width: '16px',
              height: '16px',
              borderRadius: '50%',
              position: 'absolute',
              top: '-4px',
              right: '-4px',
            }}
          />
        )}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        autoFocus={false}
        disableAutoFocusItem={true}
      >
        {/* don't delete this input */}
        <input hidden></input>
        <Box
          sx={{
            maxWidth: '360px',
            width: '100%',
            overflow: 'visible',
            position: 'relative',
            minHeight: '300px',
            pb: '12px',
          }}
        >
          <Typography
            sx={{
              px: '22px',
              pb: '12px',
              pt: '4px',
              fontWeight: 'bold',
              fontSize: '16px',
            }}
          >
            Filter
          </Typography>
          <Divider />
          <Box
            sx={{
              p: '22px',
            }}
          >
            <SearchPlot
              onSelect={() => {
                handleClose();
              }}
            />
          </Box>
          <FilterPlotStatus value={status} onChange={setStatus} />
          <Divider
            sx={{
              my: '12px',
            }}
          />
          <FilterClaimchainInMap
            value={showClaimchain}
            onChange={setShowClaimchain}
          />
          <Divider
            sx={{
              my: '12px',
            }}
          />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: '22px',
            }}
          >
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 'bold',
              }}
            >
              Show unconnected plot in map
            </Typography>

            <IOSSwitch
              checked={showUnConnect}
              onChange={(e) => {
                setShowUnConnect(e.target.checked);
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              px: '22px',
              mt: '22px',
            }}
          >
            <Button
              sx={{
                width: '48%',
              }}
              variant="outlined"
              onClick={() => {
                setState(initFilter);
              }}
            >
              Reset Filter
            </Button>
            <ButtonGradient
              sx={{
                width: '48%',
              }}
              variant="contained"
              onClick={() => {
                setFilter(state);
                handleClose();
              }}
            >
              Apply
            </ButtonGradient>
          </Box>
        </Box>
      </Menu>
    </Box>
  );
}
